import { render, staticRenderFns } from "./QuicksearchProTips.vue?vue&type=template&id=597265d3&scoped=true&"
import script from "./QuicksearchProTips.vue?vue&type=script&lang=js&"
export * from "./QuicksearchProTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597265d3",
  null
  
)

export default component.exports